import { Badge } from "@/components/ui/badge";
import { STATUS_TONE, type SubmissionStatus } from "@/features/efiling/types";
import { cn } from "@/lib/utils";

interface Props {
  status: SubmissionStatus;
  label: string;
  title?: string;
}

/** Status pill for an IRS submission. Colours come from the semantic tokens in
 * `types.ts` (no hardcoded hex). */
export function SubmissionStatusBadge({ status, label, title }: Props) {
  return (
    <Badge
      variant="outline"
      title={title}
      className={cn("border-transparent text-[11px] font-semibold", STATUS_TONE[status])}
    >
      {label}
    </Badge>
  );
}
